export const CompanyProfileSectionTitle = ({ title }: { title: string }) => {
  return <p className="text-lg font-semibold text-slate-700">{title}</p>;
};
